<template>
  <div>
    <div class="pipeline-background">
      <NEWPipelineComponent :statuses="other_statuses" />
      <NEWPipelineComponent :statuses="status_all" />
    </div>
    <ConsumptionDevicesOverviewTable />
  </div>
</template>

<script>
import ConsumptionDevicesOverviewTable from './ConsumptionDevicesOverviewTable';
import { NEWPipelineComponent } from '@newnetzportal/netzportal-webapp-storybook-components';
import { getConsumptionDevicesTableConfig } from './consumptionDevicesTableConfig';
import { getConsumptionDevicesSummaryForPipeline } from '../../services/ConsumptionDevicesService';

export default {
  name: 'ConsumptionDevicesOverviewComponent',
  components: {
    ConsumptionDevicesOverviewTable,
    NEWPipelineComponent,
  },
  created() {
    this.getConsumptionDevicesSummaryForPipelineFromBackend();
  },
  data() {
    return {
      ordersSummaryForPipeline: {},
      countOrderStatuses:
        getConsumptionDevicesTableConfig('countOrderStatuses'),
    };
  },
  computed: {
    status_all() {
      const summaryAllOrders = [
        {
          name: 'alle',
          color: '#999999',
          amount: this.ordersSummaryForPipeline.count_all,
          percentage: 100,
        },
      ];
      return summaryAllOrders;
    },
    other_statuses() {
      const otherStatuses = [];
      for (const element of this.countOrderStatuses) {
        const name = element.label;
        const amount =
          this.ordersSummaryForPipeline[`count_${element.value.toLowerCase()}`];
        const percentage =
          (amount / this.ordersSummaryForPipeline.count_all) * 100;

        // Override color if name matches "Auftrag storniert"
        const color = name === 'Auftrag storniert' ? '#828282' : element.color;

        otherStatuses.push({
          name,
          color,
          amount,
          percentage,
        });
      }
      return otherStatuses;
    },
  },
  methods: {
    getConsumptionDevicesSummaryForPipelineFromBackend() {
      getConsumptionDevicesSummaryForPipeline()
        .then((res) => {
          if (res) {
            this.ordersSummaryForPipeline = res;
          } else {
            console.warn('No data received for orders summary.');
          }
        })
        .catch((err) => {
          console.error('Error fetching pipeline data:', err);
        });
    },
  },
};
</script>
